import { ensureAnonymousAuth } from "../auth/anonymousAuth";
import { resolveActiveFunctionUrl } from "../../configs/runtimeEnvironment";

const EMPTY_IMPACT = {
  totalImpact: 0,
  startedByUser: 0,
  carriedForward: 0,
};

function resolveYourImpactUrl() {
  return resolveActiveFunctionUrl("getYourImpact", {
    devUrl: process.env.REACT_APP_GET_YOUR_IMPACT_URL_DEV,
    prodUrl: process.env.REACT_APP_GET_YOUR_IMPACT_URL_PROD,
    devFallbackUrls: [process.env.REACT_APP_CREATE_LETTUCE_TALK_CARDS_URL_DEV],
    prodFallbackUrls: [process.env.REACT_APP_CREATE_LETTUCE_TALK_CARDS_URL_PROD],
  });
}

function getCount(value) {
  return Number.isInteger(value) && value >= 0 ? value : null;
}

function parseImpactResponse(data) {
  const totalImpact = getCount(data?.totalImpact);
  const startedByUser = getCount(data?.startedByUser);
  const carriedForward = getCount(data?.carriedForward);

  if (totalImpact === null || startedByUser === null || carriedForward === null) {
    throw new Error("Invalid Your Impact response");
  }

  return { totalImpact, startedByUser, carriedForward };
}

export async function getYourImpact() {
  const url = resolveYourImpactUrl();

  const user = await ensureAnonymousAuth();
  const idToken = await user.getIdToken();

  if (!url) {
    throw new Error("Missing Your Impact function URL");
  }

  const response = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${idToken}` },
    mode: "cors",
  });
  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.error || "Failed to load Your Impact");
    error.status = response.status;
    throw error;
  }

  return parseImpactResponse(data);
}

export { EMPTY_IMPACT };
